import { useState, useEffect } from "react";

export const Faq = () => {
  const [selectFaq, setSelectFaq] = useState(0);
  return (
    <div className="section">
      <div className="container">
        <div className="text-center out-fit-headline-2">FAQ</div>
        <div className="mt-20">
          <FaqEach
            question="Who are Homies?"
            setSelectFaq={setSelectFaq}
            thisNumber={1}
            selectFaq={selectFaq}
          />
          <FaqEach
            question="What is the Community tool?"
            setSelectFaq={setSelectFaq}
            thisNumber={2}
            selectFaq={selectFaq}
          />
          <FaqEach
            question="How are we multi-chain?"
            setSelectFaq={setSelectFaq}
            thisNumber={3}
            selectFaq={selectFaq}
          />
          <FaqEach
            question="Why it is me founding the project?"
            setSelectFaq={setSelectFaq}
            thisNumber={4}
            selectFaq={selectFaq}
          />
          <FaqEach
            question="How many collection do we have?"
            setSelectFaq={setSelectFaq}
            thisNumber={5}
            selectFaq={selectFaq}
          />
          <FaqEach
            question="Wen and How much?"
            setSelectFaq={setSelectFaq}
            thisNumber={6}
            selectFaq={selectFaq}
          />
        </div>
      </div>
    </div>
  );
};

type FAQ_EACH = {
  question: string;
  answer?: string;
  setSelectFaq?: any;
  thisNumber?: number;
  selectFaq?: number;
};

export const FaqEach = ({
  question,
  answer,
  setSelectFaq,
  thisNumber,
  selectFaq,
}: FAQ_EACH) => {
  return (
    <div className="mt-14">
      <div
        className="faq-each-container cursor-pointer"
        onClick={() =>
          thisNumber !== selectFaq ? setSelectFaq(thisNumber) : setSelectFaq(0)
        }
      >
        <div className="faq-each-question ">
          <div className="out-fit-detail-text">{question}</div>

          {thisNumber !== selectFaq ? (
            <div>
              <i className="fa fa-plus-circle"></i>
            </div>
          ) : (
            <div>
              <i className="fas fa-times-circle"></i>
            </div>
          )}
        </div>

        {thisNumber === selectFaq ? (
          <div className="mt-20">
            <div className="">
              test test tes tetsts testes tes t est est test tes tetsts testes
              tes t est est test tes tetsts testes tes t est est test tes tetsts
              testes tes t est est test tes tetsts testes tes t est est test tes
              tetsts testes tes t est est test tes tetsts testes tes t est
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
